import { createFileRoute, redirect, Navigate } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { useAuth } from "../../../components/AuthProvider";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import type { RouterContextWithSession } from "../../../router";

const CortexMeshPage = lazy(
  () => import("../../../pages/Admin/CortexMeshPage"),
);

export const Route = createFileRoute("/_admin/cortex-mesh/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  loader: async ({ context }) => {
    if (typeof window === "undefined") return;
    const { session } = context as RouterContextWithSession;
    if (!session) return;
    await context.queryClient.ensureQueryData({
      queryKey: ["route", "cortex-mesh"],
      queryFn: async () => null,
      staleTime: Infinity,
    });
  },
  pendingComponent: () => <PageSkeleton rows={4} variant="cards" />,
  errorComponent: createRouteError("Cortex Mesh"),
  component: CortexMeshRoutePage,
});

function CortexMeshRoutePage() {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" />;
  }

  return (
    <Suspense fallback={<PageSkeleton rows={4} variant="cards" />}>
      <CortexMeshPage />
    </Suspense>
  );
}
